module.exports = __webpack_public_path__ + "static/first-view-district.9eee29fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/first-view-district.png
// module id = 748
// module chunks = 35783957827783